import { Box, Image, Text } from '@chakra-ui/react';
import React from 'react';
import { CommonProps } from '../../../interfaces/components';
import { Close } from '../../../Icons/Close';
import Background from '../../../assets/images/bicester/apartment_welcome.png';
import BackgroundMb from '../../../assets/images/bicester/apartment_welcome_mb.png';
import { useTranslation } from 'react-i18next';
import useWindowDimensions from '../../../utils/hooks/useWindowDimensions';

const ApartmentWelcome = ({ active, setActive }: CommonProps) => {
  const { width } = useWindowDimensions();
  const { t } = useTranslation();

  return (
    <>
      <Box
        position="fixed"
        w="100%"
        h="100%"
        top="0"
        left="0"
        opacity={active ? 1 : 0}
        visibility={active ? 'visible' : 'hidden'}
        backgroundColor="rgba(0,0,0,0.2)"
        transition="all 1s"
        zIndex={4}
        onClick={() => setActive()}
      />
      <Box
        zIndex={7}
        opacity={active ? 1 : 0}
        visibility={active ? 'visible' : 'hidden'}
        transition="all 0.5s"
        position="fixed"
        top={0}
        right={0}
        left={0}
        bottom={0}
        margin="auto"
        bg="rgba(255, 255, 255, 0.9);"
        width={['100%', '100%', '700px', '700px', '700px']}
        height={['100%', '100%', '590px', '600px', '600px']}
        display="flex"
        flexDir="column"
        justifyContent="center"
        alignItems="center"
        overflowY={['auto', 'auto', 'hidden']}
      >
        <Close
          boxSize={[6, 6, 7]}
          position="absolute"
          top={['20px', '20px', '25px']}
          right={['20px', '20px', '25px']}
          cursor="pointer"
          onClick={() => setActive()}
          zIndex={30}
        />
        <Image
          src={width < 770 ? BackgroundMb : Background}
          w="100%"
          h={['400px', '400px', '300px']}
          position="absolute"
          top="0"
          left="0"
          objectFit={['cover', 'cover', 'contain']}
          alt="cover"
        />
        <Box position="absolute" top={['435px', '435px', '335px']} left="0">
          <Text
            textAlign="center"
            fontWeight="400"
            fontSize={['16px', '16px', '18px', '20px', '20px']}
            width="100%"
            className="copy"
            fontFamily="SangBleuBPLight"
          >
            {t('bv_apartment_welcome_text_one')}
          </Text>
          <Text
            textAlign="center"
            fontWeight="400"
            fontSize={['32px', '32px', '36px', '40px', '40px']}
            mt="1"
            className="copy"
            fontFamily="SangBleuBPLight"
            maxW="80%"
            mx="auto"
          >
            {t('bv_apartment_welcome_text_two')}
          </Text>
          <Text
            textAlign="center"
            fontWeight="400"
            fontSize={['16px', '16px', '18px', '20px', '20px']}
            width="100%"
            mt="2"
            className="copy"
            fontFamily="SangBleuBPLight"
          >
            {t('bv_apartment_welcome_text_three')}
          </Text>
          <Text
            textAlign="center"
            fontWeight="400"
            fontFamily="JosefinSans"
            fontSize={['12px', '12px', '14px', '16px', '16px']}
            lineHeight={['16px', '16px', '18px', '20px', '20px']}
            maxW={['90%', '90%', '75%']}
            mx="auto"
            mt="7"
          >
            {t('bv_apartment_welcome_text_four')}
          </Text>
        </Box>
      </Box>
    </>
  );
};
export default ApartmentWelcome;
